// Which face sheet a screen loads (design 11 §4): one sheet for everything the page shows (the table's
// sprites and the page's small tiles), chosen before any script runs. The HTML asks for it at once, beside the
// scripts (a preload whose candidates are the sheets, by width, and whose size estimates the sheet the own
// row needs: vite.config.ts); the page then takes the one the browser chose, or, without it, the same choice
// made here.

/** How wide, in CSS pixels, a sheet the own row draws well from is shown: a sheet is about 8.2 face widths,
 *  a face wants 1.1 times the own row's tile, and that tile is about a 14.8th of the width upright, or a
 *  twelfth (short screens) or fourteenth of the board, about the height, on its side (styles.css). */
export const FACE_SIZES = "(orientation: portrait) calc((100vw - 24px) * 0.61), (max-height: 599px) calc(100vh * 0.71), calc(100vh * 0.61)";

/** The candidates of the preload and of the page's own request for the sheet: each sheet and its width. */
export const faceSrcset = (urls: Record<number, string>, widths: Record<number, number>) =>
  Object.keys(urls)
    .map(Number)
    .sort((a, b) => a - b)
    .map((w) => `${urls[w]} ${widths[w]}w`)
    .join(", ");

/** FACE_SIZES evaluated, in CSS pixels. */
export function faceSizes(): number {
  if (matchMedia("(orientation: portrait)").matches) return (innerWidth - 24) * 0.61;
  if (matchMedia("(max-height: 599px)").matches) return innerHeight * 0.71;
  return innerHeight * 0.61;
}
